const INITIAL_STATE = {
  usersList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_USERS':
      return { ...state, usersList: action.users };
    default:
      return state;
  }
};
